export const getValidationMessage = (validationStatus, validationMessagesMapping) => {
  const validationMessage =
    validationMessagesMapping?.[validationStatus] || validationMessagesMapping?.default;

  return validationMessage;
};
